<template>
  <div class="customs-logistics-lock-management">
    <top-nav :banner="data.banner" isParent></top-nav>
    <Pain></Pain>
    <comm-scene :dataKey="'customs-logistics-lock-management'" scene-key="applicationScenarios"></comm-scene>
    <product-list coloredbg></product-list>
    <customer-wall></customer-wall>
    <footer-resolution></footer-resolution>
    <my-footer></my-footer>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Pain from './components/pain.vue';
import CustomerWall from '@/views/index-view/customer-wall.vue';

export default {
  components: {
    Pain,
    CustomerWall
  },
  computed: {
    ...mapGetters(['globalData']),
    data() {
      return this.globalData['customs-logistics-lock-management'];
    }
  }
};
</script>

<style lang="scss" scoped>
.customs-logistics-lock-management {
  background: #ffffff;

  ::v-deep .banner-item-brief {
    width: 48%;
    font-size: 24px;
    line-height: 1.5;
    color: white !important;
    text-shadow: 1px 1px 2px #000;
  }

  ::v-deep .banner-item-title {
    color: white !important;
    text-shadow: 1px 1px 2px #000;
  }

  ::v-deep .banner-list .banner-item .banner-buttons {
    bottom: 18%;
  }
}
</style>
